import React, { useState, useEffect } from "react";
import { Button, Col, Row } from "antd";
import isEqual from "lodash.isequal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReservationTables from "./ReservationTables";
import restaurantSchemaActions from "../../../redux/restaurantSchema/actions";
import ReservationsList from "./ReservationsList";

import CreateReservationNewModal from "./ReservationTablesSubComponents/CreateReservationNewModal";

const { getReservationTable } = restaurantSchemaActions;

const ReservationComponent = ({ backgroundImage, regionId, date }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { reservations } = useSelector(
    (state) => state.restaurantReservationsReducer
  );

  const [reservationState, setReservationState] = useState(reservations);

  useEffect(() => {
    if (!isEqual(reservationState, reservations)) {
      // Get all Reservation Tables
      setReservationState(reservations);
      dispatch(getReservationTable(regionId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservations]);

  return (
    <>
      {/* <CreateReservationModal regionId={regionId} date={date} /> */}
      <CreateReservationNewModal regionId={regionId} date={date} />
      <Row gutter={16}>
        <Col xs={{ span: 24 }} md={{ span: 0 }}>
          <Button
            id="reservations-create-buttons-mobile"
            onClick={() =>
              dispatch({
                type: "OPEN_RESERVATION_CREATE_MODAL",
              })
            }
            type="primary"
          >
            Създай Резервация
          </Button>
          <Button
            id="reservations-create-buttons-mobile"
            onClick={() => navigate("/reservation-overview")}
          >
            Таблица на Резервациите
          </Button>
        </Col>
        <Col
          xs={{ span: 0, style: { display: "none" } }}
          md={{ span: 15, style: { display: "block" } }}
          lg={{ span: 17, style: { display: "block" } }}
        >
          <ReservationTables backgroundImage={backgroundImage} />
          <div className="reservations-footer-buttons">
            <Button
              onClick={() =>
                dispatch({
                  type: "OPEN_RESERVATION_CREATE_MODAL",
                })
              }
              type="primary"
            >
              Създай Резервация
            </Button>

            <Button onClick={() => navigate("/reservation-overview")}>
              Таблица на Резервациите
            </Button>
          </div>
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 9 }} lg={{ span: 7 }}>
          <ReservationsList date={date} />
        </Col>
      </Row>
    </>
  );
};
export default ReservationComponent;
